import React from 'react';
import { useI18n } from '../../lib/i18n';
import { Reveal } from '../ui/Reveal';
export function Trust() {
  const {
    t
  } = useI18n();
  const brands = ['LALIQUE', 'HERMÈS', 'CHRISTOFLE', 'SAINT-LOUIS', 'PUIFORCAT'];
  return <section className="py-24 relative bg-luxury-ivory border-y border-luxury-taupe/10 overflow-hidden" data-id="element-159">
      <div className="absolute inset-0 bg-noise opacity-20 mix-blend-overlay pointer-events-none" data-id="element-160" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center relative z-10" data-id="element-161">
        <Reveal data-id="element-162">
          <h2 className="text-2xl md:text-3xl font-heading font-medium text-luxury-charcoal mb-6" data-id="element-163">
            {t('trustTitle')}
          </h2>
          <p className="text-luxury-stone font-light max-w-2xl mx-auto mb-16" data-id="element-164">
            {t('trustBody')}
          </p>
        </Reveal>

        <Reveal delay={200} data-id="element-165">
          <div className="flex flex-wrap justify-center items-center gap-12 md:gap-20 opacity-50 grayscale" data-id="element-166">
            {brands.map((brand, idx) => <span key={idx} className="font-heading text-xl tracking-widest text-luxury-charcoal uppercase" data-id="element-167">
                {brand}
              </span>)}
          </div>
        </Reveal>

        <Reveal delay={400} data-id="element-168">
          <div className="mt-20 pt-10 border-t border-luxury-taupe/10 inline-block" data-id="element-169">
            <p className="text-xs text-luxury-gold tracking-widest uppercase font-medium" data-id="element-170">
              {t('trustFooter')}
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}